import { render, staticRenderFns } from "./RoleDataTable.vue?vue&type=template&id=f3ec2f32&"
import script from "./RoleDataTable.vue?vue&type=script&lang=js&"
export * from "./RoleDataTable.vue?vue&type=script&lang=js&"
import style0 from "./RoleDataTable.vue?vue&type=style&index=0&id=f3ec2f32&prod&language=scss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports